/**
 * @fileoverview Barrel exports for the critique-committee-v2 COMPOSITE agent.
 *
 * This is a composite agent that orchestrates three critique primitives in parallel:
 * - critique-prose-flow: Analyzes rhythm, pacing, transitions
 * - critique-sensory-atmosphere: Evaluates sensory details, atmosphere
 * - critique-voice-emotion: Assesses voice consistency, emotional resonance
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Parallel orchestration logic using executeParallel
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  CritiqueResultSchema,
  FindingSchema,
  IssueSeverityEnum,
  type Input,
  type Output,
  type CritiqueResult,
} from './schema';

// Flow
export { flow, critiqueCommitteeV2AgentFlow } from './flow';

